import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'
import { LegalFormalityDocumentContext } from 'contexts/LegalFormalityDocumentContext'
import { Button } from 'antd'
import { useMutation } from '@apollo/client'
import { LEGAL_FORMALITY_DOCUMENT_MERGE_MUTATION } from 'graphql/LegalFormalities'

const MergeableMenu = () => {
  const { t } = useTranslation()
  const { legalFormality, legalFormalityRefetch } = useContext(
    CurrentLegalFormalityContext
  )
  const { selectedDocumentListItem, currentDocument, setCurrentDocument } =
    useContext(LegalFormalityDocumentContext)
  const [mergeDocument] = useMutation(LEGAL_FORMALITY_DOCUMENT_MERGE_MUTATION)

  const mergeCallback = (data: any) => {
    console.log(data)
    const doc = data.data.legalFormalityDocumentMerge.legalFormalityDocument
    setCurrentDocument(doc)
    legalFormalityRefetch()
  }
  const handleMergeDoc = (force: boolean) => {
    currentDocument &&
      mergeDocument({
        variables: {
          purchaseId: parseInt(legalFormality.purchase.id),
          documentType: currentDocument.documentType,
          targetType:
            selectedDocumentListItem.target &&
            selectedDocumentListItem.target.type,
          targetId:
            selectedDocumentListItem.target &&
            selectedDocumentListItem.target.id,
          force: force,
        },
      }).then(mergeCallback)
  }

  const mergeDocBtn = (force = false) => (
    <Button onClick={() => handleMergeDoc(force)} size="large">
      {t(
        `legalFormalities:merge.buttons.${force ? 'reset' : 'initial'}`,
        'Merge'
      )}
    </Button>
  )

  return mergeDocBtn(true)
}

export default MergeableMenu
